import React from 'react';
import { motion } from 'framer-motion';
import './AboutUsTechnology.css';

const AboutUsTechnology: React.FC = () => {

  return (
    <motion.section
      className="about-technology"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="technology-background-image">
        <img
          src="/Untitled-design-2-1024x1024.webp"
          alt="Advanced eCOA technology interface"
          className="tech-bg-img"
        />
        <div className="technology-overlay"></div>
      </div>

      <div className="technology-content-overlay">
        <div className="about-technology-container">
        <div className="about-technology-header">
          <h2 className="about-technology-title">Advanced <span className="highlight">eCOA Technology</span></h2>
          <p className="about-technology-subtitle">Revolutionizing clinical data collection</p>
        </div>

        <div className="about-technology-showcase">
          <div className="about-tech-feature">
            <div className="about-feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2ZM17 20H7V4H17V20Z" fill="currentColor"/>
                <path d="M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 12C13.1 12 14 12.9 14 14C14 15.1 13.1 16 12 16C10.9 16 10 15.1 10 14C10 12.9 10.9 12 12 12Z" fill="currentColor"/>
              </svg>
            </div>
            <h3 className="about-feature-title">Mobile-First Design</h3>
            <p className="about-feature-text">Intuitive mobile applications that patients love to use</p>
          </div>

          <div className="about-tech-feature">
            <div className="about-feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 7C13.1 7 14 7.9 14 9C14 10.1 13.1 11 12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7ZM12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13Z" fill="currentColor"/>
              </svg>
            </div>
            <h3 className="about-feature-title">Data Security</h3>
            <p className="about-feature-text">Enterprise-grade security with HIPAA compliance</p>
          </div>

          <div className="about-tech-feature">
            <div className="about-feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 3C13 2.45 12.55 2 12 2S11 2.45 11 3V4H9C7.9 4 7 4.9 7 6V18C7 19.1 7.9 20 9 20H15C16.1 20 17 19.1 17 18V6C17 4.9 16.1 4 15 4H13V3ZM15 18H9V6H15V18ZM11 8H13V10H11V8ZM11 12H13V14H11V12ZM11 16H13V18H11V16Z" fill="currentColor"/>
              </svg>
            </div>
            <h3 className="about-feature-title">Real-Time Analytics</h3>
            <p className="about-feature-text">Live data monitoring and instant insights</p>
          </div>

          <div className="about-tech-feature">
            <div className="about-feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20ZM12 6C8.69 6 6 8.69 6 12S8.69 18 12 18 18 15.31 18 12 15.31 6 12 6ZM12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12 14.21 16 12 16Z" fill="currentColor"/>
                <circle cx="12" cy="12" r="2" fill="currentColor"/>
              </svg>
            </div>
            <h3 className="about-feature-title">Global Scalability</h3>
            <p className="about-feature-text">Multi-language support across 50+ countries</p>
          </div>
        </div>

        </div>
      </div>
    </motion.section>
  );
};

export default AboutUsTechnology;
